<template>
  <span class="hm-badge" :class="{ 'hm-badge--removable': showRemove }">
    <span class="text">
      <slot></slot>
    </span>
    <span class="badge-option-icon" v-if="showEdit">
      <font-awesome-icon :icon="['far', 'pen']" @click="$emit('edit')" />
    </span>
    <span class="badge-option-icon" v-if="showRemove">
      <font-awesome-icon :icon="['far', 'times']" @click="$emit('remove')" />
    </span>
  </span>
</template>

<script>
export default {
  name: 'HMBadge',
  computed: {
    showEdit() {
      return this.$listeners && this.$listeners.edit;
    },
    showRemove() {
      return this.$listeners && this.$listeners.remove;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-badge {
  display: inline-flex;
  justify-content: center;
  align-items: stretch;
  color: $dark-gray;
  background-color: $light-gray;
  border-radius: 6px;
}

.text {
  padding: 2px 0.5rem;
}

.hm-badge--removable .text {
  padding: 2px 0 2px 0.5rem;
}

.badge-option-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 2px 0.5rem;
  cursor: pointer;
  &:hover {
    color: $coral;
  }
}
</style>
